import React from "react";

function Title2() {
  return (
    <div className="title-line-desktop-80">
      <div className="title-block1">Name of document</div>
      <div className="title-block2">Signed</div>
      <div className="title-block3">Actions</div>
    </div>
  );
}

export default Title2;
